'use client'

import { Pagination } from '@gyym/ui'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

export interface PagerProps {
  /**
   * Current page
   */
  currentPage: number

  /**
   * Total pages
   */
  totalPages: number
}

export const Pager = ({ currentPage, totalPages }: PagerProps) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const query = new URLSearchParams(Array.from(searchParams?.entries() ?? []))

  return (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      onChange={(page) => {
        query?.set('page', page.toString())
        router.push(`${pathname ?? '/'}?${query.toString()}`)
      }}
    />
  )
}
